<template>
    <div class="skeleton-mv skeleton-el">
        <div class="block1 block"></div>
        <div>
            <div class="block2 block"></div>
            <div class="block3 block"></div>
            <div class="block4">
                <div class="block"></div>
                <div class="block"></div>
            </div>
            <ul class="block5">
                <li>
                    <div class="block"></div><div class="block"></div>
                </li>
                <li>
                    <div class="block"></div><div class="block"></div>
                </li>
                <li>
                    <div class="block"></div><div class="block"></div>
                </li>
                <li>
                    <div class="block"></div><div class="block"></div>
                </li>
            </ul>
            <div class="block6 block"></div>
            <div class="block7 block"></div>
            <div class="block8 block"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'SkeletonMv',
};
</script>
<style lang="scss" scoped>
.skeleton-mv {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    .block {
        background: #F0F0F0;
    }
    & > * {
        &:last-child {
            margin: 0 30px;
        }
    }
    .block1 {
        height: 300px;
        border-radius: 0;
    }
    .block2 {
        width: 110px;
        height: 48px;
        margin: 20px 0 20px;
        border-radius: 24px;
    }
    .block3 {
        width: 216px;
        height: 216px;
    }
    .block4 {
        @include SpaceBetween();
        margin: 40px 0;
        div {
            height: 36px;
            &:first-child {
                width: 136px;
                border-radius: 18px;
            }
            &:last-child {
                width: 310px;
                border-radius: 18px;
            }
        }
    }
    .block5 {
        @include SpaceBetween();
        flex-wrap: wrap;
        li {
            width: 330px;
            div {
                &:first-child {
                    height: 186px;
                }
                &:last-child {
                    width: 120px;
                    height: 36px;
                    border-radius: 18px;
                    margin: 20px auto 30px;
                }
            }
        }
    }
    .block6 {
        width: 120px;
        height: 36px;
        border-radius: 18px;
        margin: 15px 0 68px;
    }
    .block7 {
        width: 230px;
        height: 36px;
        border-radius: 18px;
        margin: 0 auto;
    }
    .block8 {
        width: 400px;
        height: 80px;
        border-radius: 40px;
        margin: 90px auto 0;
    }
}
</style>
